import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconXBrandedDarkStyle0 = cosmosIconCss;

const CosmosIconXBrandedDark$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconXBrandedDark extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cb329a3fcb4a31917ceb2c52ad220878fc7139fd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0c4bae7cd5ccf57d834a3315f0e98fd0cf206482', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7fbcde1baec82b2074518b046e4efc777ac2d041', d: "M12.317 9.775 18.144 3h-1.38l-5.06 5.883L7.66 3H3l6.112 8.896L3 19h1.381l5.344-6.212L13.993 19h4.661l-6.338-9.225Zm-1.892 2.199-.62-.886L4.88 4.04H7l3.977 5.688.62.886 5.168 7.393h-2.121l-4.218-6.033Z", fill: "#000" }))));
    }
    static get style() { return CosmosIconXBrandedDarkStyle0; }
}, [1, "cosmos-icon-x-branded-dark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-x-branded-dark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-x-branded-dark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconXBrandedDark$1);
            }
            break;
    } });
}

const CosmosIconXBrandedDark = CosmosIconXBrandedDark$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconXBrandedDark, defineCustomElement };
